import { rei } from "@/services/api"

class LivroCaixaService {
  static getLancamentos (params) {
    return rei.get(`livro-caixa-lancamento`, {params}).then(res => res.data)
  }

  static cadastrarLancamento (lancamento) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    const formData = new FormData()

    Object.keys(lancamento).forEach(key => {
      const value = key === 'categoria' || key === 'fornecedor' ? JSON.stringify(lancamento[key]) : lancamento[key]

      if (key === 'livroCaixaLancamentoArquivo') {
        lancamento.livroCaixaLancamentoArquivo.forEach(file => {
          formData.append('files[]', file)
        })
      } else if (value) {
        formData.append(key, value)
      }
    })

    return rei.post(`livro-caixa-lancamento`, formData, config).then(res => res.data)
  }

  static atualizarLancamento (lancamento, id) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    const formData = new FormData()

    Object.keys(lancamento).forEach(key => {
      if (!lancamento[key]) return

      const value = key === 'categoria' || key === 'fornecedor' ? JSON.stringify(lancamento[key]) : lancamento[key]

      if (key === 'livroCaixaLancamentoArquivo') {
        lancamento.livroCaixaLancamentoArquivo.forEach(file => {
          if (!file.pdf) formData.append('files[]', file)
        })
      } else if (key === 'deleteds') {
        lancamento.deleteds.forEach(item => {
          formData.append('deleteds[]', item)
        })
      } else {
        formData.append(key, value)
      }
    })
    return rei.put(`livro-caixa-lancamento/${id}`, formData, config).then(res => res.data)
  }

  static excluirLancamento (id) {
    return rei.delete(`livro-caixa-lancamento/${id}`)
  }

  static getDocumentos (id) {
    return rei.get(`livro-caixa-lancamento-arquivo/${id}`).then(res => res.data)
  }

  static getPDF (url) {
    const config = {
      responseType: 'arraybuffer'
    }

    return rei.get(`visualizar-arquivo-livro-caixa-lancamento?url_s3=${url}`, config).then(res => res.data)
  }

  static relatorioLivroCaixa (params) {
    if (params.tipo_relatorio === 'PDF') {
      return rei.post(`relatorio-livro-caixa`, params, {
        responseType: 'arraybuffer',
        timeout: 60000
      }).then((res) => {
        let blob = new Blob([res.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      }).catch((e) => {
        if (e.message && e.message.search('code 400') >= 0) {
          // Fazermos essa request para obter o tipo de response em json
          return rei.post(`relatorio-livro-caixa`, params)
        }

        throw e
      })
    }

    if (params.tipo_relatorio === 'EXCEL') {
      return rei.post(`relatorio-livro-caixa`, params, {
        responseType: 'arraybuffer',
        timeout: 60000
      }).then((res) => res)
    }
  }

  static ajusteLacamentoLivroCaixa () {
    return rei.get('ajuste-lacamento-livro-caixa').then(res => res.data)
  }
}

export default LivroCaixaService
